import { useState, useEffect } from 'react';
import { getAppInfo, type AppInfo } from '@/api/app';

export function useAppVersion(): AppInfo | null {
  const [appInfo, setAppInfo] = useState<AppInfo | null>(null);

  useEffect(() => {
    getAppInfo()
      .then((info) => {
        if (info) setAppInfo(info);
      })
      .catch(() => {
        // silently ignore version fetch errors
      });
  }, []);

  return appInfo;
}
